import rpc from '@square/web-rpc-client/rpc';
export default function reactRpc(input) {
    return rpc(input.urlForMethod, input.loggerFactory, input.errorDeserializer, input.additionalHeaders, input.responseParser, input.sendSpeleoTraceId, undefined, undefined, input.signal);
}
